import { heroData } from "@/mocks/homeData";

export default function HeroSection() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20enterprise%20technology%20background%20with%20subtle%20geometric%20network%20lines%20and%20soft%20green%20amber%20glow%2C%20minimal%20modern%20corporate%20digital%20art%2C%20deep%20charcoal%20base%20with%20muted%20warm%20accents%2C%20no%20text%2C%20editorial%20quality&width=1600&height=900&seq=hero-2026-r1&orientation=landscape"
          alt="Enterprise technology abstract background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/60 to-foreground-950/40" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 pt-20 md:pt-24 pb-16 md:pb-20">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/15 border border-accent-500/30 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse" />
            <span className="text-xs md:text-sm font-medium text-accent-400">
              Trusted by Banks & Enterprises for 20+ Years
            </span>
          </div>

          <h1 className="font-heading font-bold text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-5">
            {heroData.headline}
          </h1>

          <p className="text-base md:text-lg text-background-200 leading-relaxed mb-8 max-w-2xl">
            {heroData.subheadline}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <button
              onClick={() => handleNavClick("#services")}
              className="px-6 py-3.5 text-sm font-semibold rounded-md bg-accent-500 text-foreground-950 hover:bg-accent-400 transition-colors whitespace-nowrap text-center cursor-pointer"
            >
              {heroData.ctaPrimary}
            </button>
            <button
              onClick={() => handleNavClick("#contact")}
              className="px-6 py-3.5 text-sm font-semibold rounded-md border border-background-300/60 text-background-50 hover:bg-background-50/10 transition-colors whitespace-nowrap text-center cursor-pointer"
            >
              {heroData.ctaSecondary}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}